<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">

                <div class="card card-header-actions ">
                    <div class="card-header">
                        Vaccine Creation
                        <button class="btn btn-blue btn-icon float-right" (click)="openModal()"
                                *ngIf="!showDetails && (screennames?.screen_name == 'vaccinecreation' ? screennames.can_insert : '')">
                                <i class="fa fa-plus"></i>
                            </button>
                        <a class="float-right"  style="cursor: pointer;" *ngIf="showDetails" (click)="onBack()">Back</a>
                    </div>
                    <div class="card-body">

                        <div class="row mt-4">
                            <div class="col-xl-12" *ngIf="showList">
                                <div class="table-responsive">
                                    <table datatable [dtOptions]="dtOptions" *ngIf="dtRender"
                                        class="table table-striped table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th style="width:5%">S.No</th>
                                                <th>Vaccine Name</th>
                                                <th>Vaccine Code</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of lstGrid;let i=index">
                                                <td>{{i+1}}</td>
                                                <td>{{item.vaccine_name}}</td>
                                                <td>{{item.vaccine_code}}</td>
                                                <td>{{item.is_active==true?'Active':'In Active'}}</td>
                                                <td>
                                                     <span>
                                                <a class="badge badge-info badge-pill pointer" title="Edit"  *ngIf="!showDetails && (screennames?.screen_name == 'vaccinecreation' ? screennames?.can_update : '')"
                                                    (click)="onEdit(item,'e')">
                                                    <i class="fa fa-edit text-white"></i></a>&nbsp;
                                            </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showDetails">
                            <form [formGroup]="vaccineRegForm">
                                <div class="row">
                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3 mb-2">
                                        <label class="form-label">Vaccine Name <span
                                                class="text-danger"  >*</span>:</label>
                                    </div>
                                    <div class="col-xl-3 mb-2">
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="vaccine_name" maxlength="50" size="30"
                                            [ngClass]="{'is-invalid': submitted && fc.vaccine_name.errors}">
                                            <div *ngIf="submitted && fc.vaccine_name.errors" class="invalid-feedback">
                                                <div *ngIf="fc.vaccine_name.errors['required']">Vaccine Name is required
                                                </div>
                                            </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3 mb-2">
                                        <label class="form-label">Vaccine Code <span
                                                class="text-danger">*</span>:</label>
                                    </div>
                                    <div class="col-xl-3 mb-2">
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="vaccine_code" maxlength="50" size="30"
                                            [ngClass]="{'is-invalid': submitted && fc.vaccine_code.errors}">
                                            <div *ngIf="submitted && fc.vaccine_code.errors" class="invalid-feedback">
                                                <div *ngIf="fc.vaccine_code.errors['required']">Vaccine Code is required
                                                </div>
                                            </div>
                                    </div>
           

                                </div>
                                <div class="row">
                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3 mb-2">
                                        <label class="form-label">Description <span
                                                class="text-danger">*</span>:</label>
                                    </div>
                                    <div class="col-xl-3 mb-2">
                            <textarea autocomplete="off" id="description" formControlName="description"
                                class="form-control form-control-sm" rows="3"
                                [ngClass]="{ 'is-invalid': submitted && fc.description.errors }"
                                onkeypress='return ((event.charCode == 37)||(event.charCode >= 48 && event.charCode <= 57)||(event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)|| event.charCode == 32)'></textarea>
                            <div *ngIf="submitted && fc.description.errors" class="invalid-feedback">
                                <div *ngIf="fc.description.errors.required">Description is required</div>
                            </div>
                        </div>
                               </div>
                                <div class="row mt-2">

                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3">
                                        <label class="control-label"> Status : </label>
                                    </div>
                                    <div class="col-xl-3">
                                        <input type="radio" formControlName="is_active" [value]=true>Active
                                        <input type="radio" formControlName="is_active" [value]=false>In Active
                                    </div>
                                </div>
                            </form>

                            <div class="text-center mt-4">

                                <button type="button" class="btn btn-sm btn-primary" (click)="onSave()"><i
                                        class="fa fa-save"></i> {{!isEdit ? ' Save' : ' Update'}}</button>&nbsp;&nbsp;
                                <button type="button" class="btn btn-sm btn-danger" (click)="onBack()">
                                    <i class="fa fa-close"></i> Cancel</button>


                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>